export class ContentItemCategory implements IContentItemCategory {
    id?: string;
    dateCreated?: Date;
    createdByPersonId?: string | undefined;
    title?: string | undefined;

    constructor(data?: IContentItemCategory) {
        if (data) {
            for (const property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : <any>undefined;
            this.createdByPersonId = _data["createdByPersonId"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): ContentItemCategory {
        data = typeof data === 'object' ? data : {};
        const result = new ContentItemCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : <any>undefined;
        data["createdByPersonId"] = this.createdByPersonId;
        data["title"] = this.title;
        return data;
    }
}

export interface IContentItemCategory {
    id?: string;
    dateCreated?: Date;
    createdByPersonId?: string | undefined;
    title?: string | undefined;
}